export default "__VITE_ASSET__ivHwCsvk__"